import { render } from "./TaskSvgIcon.vue?vue&type=template&id=3f121d5f"
import script from "./TaskSvgIcon.vue?vue&type=script&lang=js"
export * from "./TaskSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__